<p-dialog
  [header]="'Settings::WorkEnvironment:Skills:NewSkillTitle' | abpLocalization"
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{ width: '26rem', maxWidth: '90vw' }"
  (onHide)="onHide()">
  <form [formGroup]="form" (ngSubmit)="onSave()">
    <label for="skillName" class="form-label text-uppercase fw-semibold small mb-1">
      {{ 'Settings::WorkEnvironment:Skills:SkillName' | abpLocalization }}
    </label>
    <input
      id="skillName"
      type="text"
      pInputText
      class="form-control w-100"
      maxlength="100"
      formControlName="name"
      [placeholder]="'Settings::WorkEnvironment:Skills:SkillNamePlaceholder' | abpLocalization" />
  </form>

  <ng-template #footer>
    <cx-form-actions
      layout="dialog"
      cancelVariant="outline-secondary"
      [cancelLabel]="'AbpUi::Cancel' | abpLocalization"
      [saveLabel]="'::Save' | abpLocalization"
      saveType="button"
      [disabled]="form.invalid || isSubmitting"
      [isSubmitting]="isSubmitting"
      (cancel)="onCancel()"
      (save)="onSave()">
    </cx-form-actions>
  </ng-template>
</p-dialog>
